import { ImageButton, styleConstants } from '@paywithextend/components'
import React from 'react'
import { useDispatch } from 'react-redux'
import { ButtonTypes } from 'src/components/Button/Button'
import SvgCheckFilled from 'src/components/Svgs/SvgCheckFilled'
import SvgClose from 'src/components/Svgs/SvgClose'
import SvgFilledAlert from 'src/components/Svgs/SvgFilledAlert'
import SvgLightningBolt from 'src/components/Svgs/SvgLightningBolt'
import { TagIcon } from 'src/components/TagIcon/TagIcon'
import {
  AttachmentUploadType,
  ReceiptAttachmentModel,
} from 'src/models/receiptAttachment.models'
import { ConnectedPlatformStatus } from 'src/models/transaction.models'
import { createSetIsAttachmentPopupOpen } from 'src/redux/actions/app.actions'
import { css } from 'styled-components'

interface AttachmentThumbnailProps {
  deleteAttachment?: (attId: string) => void
  isDeleting?: boolean
  attachment: ReceiptAttachmentModel
  setErrors?: (onlyOneReceipt: boolean) => void
  errors?: boolean
  quickDeleteIcon?: boolean
  syncedToERPStatus?: ConnectedPlatformStatus
}

const AttachmentThumbnail: React.FC<AttachmentThumbnailProps> = (
  props,
): React.ReactElement => {
  const dispatch = useDispatch()

  return props.attachment !== undefined ? (
    <div
      css={css`
        margin-right: 10px;
        margin-bottom: 5px;
        position: relative;
      `}
    >
      {props.syncedToERPStatus === ConnectedPlatformStatus.Success ? (
        <SvgCheckFilled
          css={css`
            position: absolute;
            top: -6px;
            right: -6px;
          `}
        />
      ) : props.syncedToERPStatus === ConnectedPlatformStatus.Failed ? (
        <SvgFilledAlert
          css={css`
            position: absolute;
            top: -6px;
            right: -6px;
          `}
        />
      ) : (
        (props.attachment.uploadType === AttachmentUploadType.APP ||
          props.attachment.uploadType === AttachmentUploadType.EMAIL ||
          props.attachment.uploadType ===
            AttachmentUploadType.PHONE_MESSAGE) && (
          <div
            css={css`
              position: absolute;
              top: -6px;
              right: -6px;
            `}
          >
            <TagIcon
              backgroundColor={styleConstants.colors.purple_light}
              icon={
                <SvgLightningBolt fill={styleConstants.colors.purple_dark} />
              }
            />
          </div>
        )
      )}
      {!!props.quickDeleteIcon &&
        props.syncedToERPStatus !== ConnectedPlatformStatus.Success && (
          <div
            onClick={(): void => {
              props.deleteAttachment?.(props.attachment.id)
            }}
            onKeyPress={(): null => {
              return null
            }}
            role="button"
            tabIndex={0}
            css={css`
              position: absolute;
              top: 2px;
              right: 2px;
              background-color: ${styleConstants.colors.white};
              width: 24px;
              height: 24px;
              border-radius: 12px;
              cursor: pointer;
            `}
          >
            <SvgClose />
          </div>
        )}
      <ImageButton
        onClick={(): void => {
          dispatch(
            createSetIsAttachmentPopupOpen(
              true,
              props.deleteAttachment !== undefined &&
                props.syncedToERPStatus !== ConnectedPlatformStatus.Success
                ? (): void => {
                    if (props.errors) {
                      props.setErrors?.(true)
                    } else if (props.deleteAttachment !== undefined) {
                      props.deleteAttachment(props.attachment.id)
                      props.setErrors?.(false)
                    }
                  }
                : undefined,
              props.attachment,
            ),
          )
        }}
        css={css`
          background-color: ${styleConstants.colors.white};
          ${!!props.isDeleting &&
          css`
            opacity: 0.5;
          `};
        `}
        src={props.attachment.urls.thumb}
        alt={''}
        type={ButtonTypes.button}
      />
    </div>
  ) : (
    <div />
  )
}

export default AttachmentThumbnail
